<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                    <label>GRI Date</label>
                                        <b-form-input type="date" v-model="gri.gri_date" :disabled="lockEntry" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label for="reference_num">Reference Number</label>
                                    <b-form-input type="text" v-model="gri.reference_num" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <label for="location_id">Into Location (Warehouse)</label>
                                <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="gri.location_id" :disabled="lockEntry" />
                        </b-col>
                        <b-col sm="6">
                            <label for="supplier_name">Supplier</label>
                                <supplierLookup v-bind:url="apiSupplierUrl" v-on:selected="setSupplier($event)" :lookupId="gri.supplier_id" :disabled="lockEntry"/>     
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col sm="12">
                            <label for="remarks">Remarks</label>
                            <textarea class="form-control" rows="5" id="remarks" v-model="gri.remarks" :disabled="lockEntry"></textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="gri.location_id != '' && !noItemsFound">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>GRI Items</strong>
                    </div>
                    <table class='table table-striped table-bordered'>
                            <thead>
                                <th style="min-width:300px">Product Name</th>
                                <th width="250px">Product Code</th>
                                <th width="150px">SOH</th>
                                <th width="180px">Receive Qty</th>
                                <th width="180px">Unit GMP ({{gri.currency_id}})</th>
                                <th width="180px">Total Amount ({{gri.currency_id}})</th>
                                <th width="30px"></th>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in gri.gri_items">
                                    <td>
                                        <productLookup v-bind:url="apiLocationProductUrl" v-on:selected="setProduct($event, index)" :lookupId="row.product_id" :q2="gri.location_id" :disabled="lockEntry"/>
                                    </td>
                                    <td >{{row.product_id}}</td>
                                    <td v-if="!lockEntry">{{row.qty_soh*1 + row.qty*1}}</td>
                                    <td v-if="lockEntry">{{row.qty_soh*1}}</td>
                                    <td><input type="number" min="0" name="qty" v-model="row.qty" class="form-control" :disabled="lockEntry"/></td>
                                    <td>{{row.unit_gmp}}</td>
                                    <td>{{((row.qty * 1) * (row.unit_gmp * 1)).toFixed(2)}}</td>
                                    <td><a href="#" @click="removeRow(index)" v-if="!lockEntry" tabindex="-1"><i class='fa fa-trash' style="font-size:25px;color:red;"></i></a></td>
                                </tr>
                                <tr>
                                    <td colspan=7>
                                        <b-button type="submit" size="md" variant="success" @click="addRow" v-if="!lockEntry">Add Product</b-button>
                                    </td>
                                </tr>
                            </tbody>
                    </table>
                </b-card>
            </b-col>
        </b-row>
        <b-row  v-if="gri.location_id != '' && noItemsFound">
                <b-col sm="12">
                    <div align="center">
                        <strong style="color:red">No Products Found in the Selected Warehouse! Please Select a Different Warehouse</strong>
                    </div>                    
                </b-col>
        </b-row>
        <b-row v-if="gri.location_id != '' && !noItemsFound">
            <b-col sm="12">
                    <b-row style="padding: 0px 0px 20px 18px;">
                            <b-button type="submit" size="lg" variant="primary" @click="save" v-if="!lockEntry && hideBtn">Save GRI</b-button>
                            &nbsp;&nbsp;                                                        
                            <b-button type="submit" size="lg" variant="danger" @click="closeGri" v-if="!lockEntry">Cancel</b-button>
                            <b-button type="submit" size="lg" variant="success" @click="print" v-if="lockEntry">Print</b-button>&nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="danger" @click="back" v-if="lockEntry">Back</b-button>
                    </b-row>
            </b-col>
        </b-row>
        <b-modal v-model="modalShow" @ok="handleOk" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
            <p style="color:darkblue">Confirmed Save GRI?</p>
        </b-modal>
        <b-modal v-model="modalCancelShow" @ok="handleCancelOk" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
            <p style="color:darkblue">Confirmed Cancel GRI?</p>
        </b-modal>
        <b-modal ref="myModalRef" hide-header-close hide-footer title="Good Return Outwards" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center">
                <p>Goods Return Inwards <strong style="color:green"> {{griDocNo}}</strong> is saved.<br/><br/></p>
            </div>
                <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
        </b-modal>
        <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center">
                <p style="color:red">{{errorMessage}}</p>
            </div>
                <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
        </b-modal>        
    </div>
</template>
<script>
import axios from 'axios'
import supplierLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import {authHeader, apiSupplierLookup, apiWarehouseLookup, apiLocationProductUrl, apiGriSave,apiGriGet,apiCountryLookup} from '@/functions/common.vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};
export default
{
    components: {supplierLookup,warehouseLookup,productLookup},
    created()
    {
        this.gri_ref = this.$route.params.griNum
        if(this.gri_ref == '_new')
        {
            let curDate = new Date()
            curDate = curDate.toISOString().substr(0,10)
            this.gri.gri_date = curDate
            this.noItemsFound = true
        }
        else
        {
            this.lockEntry = true
            this.fetch(this.gri_ref)
            this.noItemsFound = false
        }
    },
    data: () => {
        return {
            title:'New GRI',
            apiSupplierUrl:apiSupplierLookup,
            apiWarehouseUrl:apiWarehouseLookup,
            apiLocationProductUrl:apiLocationProductUrl,
            gri_ref: '',
            modalShow:false,
            country_name:'',
            modalCancelShow:false,
            hideBtn:true,
            prevWhId:'',
            noItemsFound:true,
            font:'ukai',
            lockEntry:false,
            griDocNo:'test',
            errorMessage:'',
            gri:
            {
                gri_date:'',
                reference_num:'',
                supplier_id:'',
                location_id:'',
                remarks:'',
                currency_id:'',
                gri_items :[
                  {product_name:'', product_id:'', qty_soh:'', qty:'', unit_gmp:'', amount_total:''}
                ]
            }
        }
    },
    methods:
    {
        print() 
        {
            console.log(this.gri)
                var gri_num = this.gri.gri_num
                var row = []
                var date = new Date(this.gri.gri_date)
                var griDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                var griItems = []
                var griTotalAmount =0;
                var supplier ='-'
                var currency = '-'
                if(this.gri.currency_id != null)
                {
                    currency= this.gri.currency_id
                }
                if(this.gri.supplier_name != null && this.gri.supplier_id != null)
                {
                    supplier = this.gri.supplier_name + ' (' + this.gri.supplier_id + ')'
                }
            
                row = [{
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'Product Code',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Description',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'SOH',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Unit GMP',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Receive Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Amount',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    }
                ]
                griItems.push(row)
                var items = this.gri.gri_items
                for (let key in items) {
                    var data = items[key]
                    griTotalAmount = griTotalAmount + (data.amount_total * 1)
                    var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var unit_gmp = ''
                    if(data.unit_gmp !=  null)
                    {
                        unit_gmp = (data.unit_gmp *1).toFixed(2)
                        unit_gmp = data.unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
 
                    var amount_total = (data.amount_total * 1).toFixed(2)
                    amount_total = data.amount_total
                    var totalAmount = data.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    console.log(data.product_name)
                    var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                    if (data.product_name == null) 
                    {
                        data.product_name = ""
                    }
                    row = [{
                            text: (key * 1) + 1,
                            style: 'itemText'
                        },
                        {
                            text: data.product_id,
                            style: 'itemText'
                        },
                        {
                            text: data.product_name,
                            style: 'itemText'
                        },
                        {
                            text: soh,
                            style: 'itemText'
                        },
                        {
                            text:unit_gmp,
                            style: 'itemText'
                        },
                        {
                            text: qty,
                            style: 'itemNumber'
                        },
                        {
                            text: totalAmount,
                            style: 'itemTotal'
                        }
                    ]
                    griItems.push(row)
                }
                griTotalAmount = griTotalAmount.toFixed(2)
                griTotalAmount = griTotalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                var ddHeader = {
                    columns: [
                        [{
                                text: 'ELKEN ' + this.country_name +' GOODS RETURN INWARDS',
                                style: 'invoiceTitle',
                                width: '*'
                            },
                            {
                                stack: [{
                                        columns: [
                                            {
                                                text: 'GRI #',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: gri_num,
                                                style: 'invoiceSubValue',
                                                width: 100

                                            },

                                        ]
                                    },
                                    {
                                        text:' '
                                    },
                                    {
                                        columns: [

                                            {
                                                text: 'GRI Date',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: griDate,
                                                style: 'invoiceSubValue',
                                                width: 100

                                            },

                                        ]

                                    },
                                    {
                                        text:' ',
                                    },
                                    {
                                        columns: 
                                        [
                                            {
                                                text: 'Supplier',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: supplier,
                                                style: 'invoiceSubValue',
                                            }

                                        ]

                                    },
                                    {
                                        text:' '
                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Stock Location',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.gri.location_id,
                                                style: 'invoiceSubValue',
                                            },

                                        ]
                                    },
                                    {
                                        text:' ',
                                    },
                                    {
                                        columns: [{
                                                text: 'Reference #',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.gri.reference_num,
                                                style: 'invoiceSubValue',
                                                width: 100

                                            },
                                        ]
                                    },
                                    {
                                        text:' ',
                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Currency',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: currency,
                                                style: 'invoiceSubValue',
                                                width: 100

                                            },
                                        ]
                                    },
                                ]
                            }
                        ],
                    ],
                }

                var dd = {
                    header: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 10, 0, 0],
                            columns: [{
                                    text: '',
                                    style: 'documentHeaderLeft'
                                },
                                {
                                    text: gri_num,
                                    style: 'documentHeaderCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentHeaderRight'
                                }
                            ]
                        }
                    },
                    footer: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 0, 0, 50],
                            columns: [{
                                    text: '',
                                    style: 'documentFooterLeft'
                                },
                                {
                                    text: 'Page ' + pageNumber + " of " + pageCount,
                                    style: 'documentFooterCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentFooterRight'
                                }
                            ]
                        };
                    },
                    content: [
                        ddHeader,
                        // Line breaks
                        '\n\n',
                        {
                            layout: 'lightHorizontalLines',
                            table: {

                                headerRows: 1,
                                widths: [25, 68, '*', 45, 45, 38, 55],
                                body: griItems

                            }, // table
                        },
                        // TOTAL
                        {
                            table: {
                                // headers are automatically repeated if the table spans over multiple pages
                                // you can declare how many rows should be treated as headers
                                headerRows: 0,
                                widths: ['*', 80],
                                body: [
                                    // Total
                                    [{
                                            text: 'TOTAL ($)',
                                            style: 'itemsFooterTotalTitle',
                                            alignment: 'right'

                                        },
                                        {
                                            text: griTotalAmount,
                                            style: 'itemsFooterTotalValue',
                                            alignment: 'right'
                                        }
                                    ],
                                ]
                            }, // table
                            layout: 'lightHorizontalLines'
                        },
                        {
                            text: 'Remarks',
                            style: 'notesTitle'
                        },
                        {
                            text: this.gri.remarks,
                            style: 'notesText'
                        },
                        {
                                columns: [
                                        {
                                            stack: [
                                                { 
                                                    text: 'Issued By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  : '+this.gri.user_shortname,
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  : ' + griDate,
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: '  ',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '                      ',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: '  ',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: '      ',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 180
                                        }, 
                                        {
                                            stack: [
                                                { 
                                                    text: 'Received By',
                                                    style:'signaturePlaceholder'
                                                },

                                                { 
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                { 
                                                    text: 'Name  :',
                                                    style:'signatureName'
                                                    
                                                },
                                                { 
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'
                                                    
                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        }, 
                    ],
                    styles: {
                        // Document Header
                        documentHeaderLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentHeaderCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentHeaderRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Document Footer
                        documentFooterLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentFooterCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentFooterRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Invoice Title
                        invoiceTitle: {
                            fontSize: 22,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 15]
                        },
                        // Invoice Details
                        invoiceSubTitle: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        invoiceSubValue: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        // Billing Headers
                        invoiceBillingTitle: {
                            fontSize: 14,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 20, 0, 5],
                        },
                        // Billing Details
                        invoiceBillingDetails: {
                            alignment: 'left'

                        },
                        invoiceBillingAddressTitle: {
                            margin: [0, 7, 0, 3],
                            bold: true
                        },
                        invoiceBillingAddress: {

                        },
                        // Items Header
                        itemsHeader: {

                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true
                        },
                        // Item Title
                        itemTitle: {
                            bold: true,
                        },
                        itemSubTitle: {
                            //italics: true,
                            fontSize: 10
                        },
                        itemText: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'left',
                        },
                        itemNumber: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'right',
                        },
                        itemTotal: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },

                        // Items Footer (Subtotal, Total, Tax, etc)
                        itemsFooterSubTitle: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterSubValue: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        itemsFooterTotalTitle: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterTotalValue: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        signaturePlaceholder: {
                            fontSize: 10,
                            margin: [0, 70, 0, 0],
                        },
                        signatureName: {
                            fontSize: 10,
                            margin: [0, 10, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        signatureJobTitle: {
                            fontSize: 10,
                            margin: [0, 20, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        notesTitle: {
                            fontSize: 10,
                            bold: true,
                            margin: [0, 30, 0, 3],
                        },
                        notesText: {
                            fontSize: 10
                        },
                        center: {
                            alignment: 'center',
                        },
                    },
                    defaultStyle: {
                        columnGap: 20,
                        font:this.font
                    }
                }
                pdfMake.createPdf(dd).open();
            },
        addRow ()
        {
            this.gri.gri_items.push({product_id:'', product_name:'', qty_soh:'', qty:'',unit_gmp:'', amount_total:''});      
        },
        removeRow (index) 
        {
            this.gri.gri_items.splice(index, 1);
        },
        setSupplier(obj)
        {
            if(!this.lockEntry)
            {
                if (obj !== null)
                {
                    this.gri.supplier_id  = obj.id
                    this.gri.currency_id = obj.currency_id 
                } 
                else
                {
                    this.gri.supplier_id  = null
                    this.gri.currency_id = null
                }

            }
        }, 
        setWarehouse(obj)
        {
            if(!this.lockEntry)
            {
                var id
                var country_id

                if (obj !== null)
                {
                    if (obj.id != this.gri.location_id)
                    {
                        id = obj.id
                        country_id = obj.country_id
                        this.gri.gri_items = []
                        this.gri.location_id = id
                        this.countryId = country_id
                        if (this.gri.location_id != '')
                        {
                           axios.get(this.apiLocationProductUrl,{params: {q:'', q2: id}})
                                .then (res => { 
                                    var list
                                    list = res.data.data.list
                                    this.noItemsFound = (list.length == 0)
                                })
                                .catch(error => alert(error))
                        }
                    }
                } 
                else
                {
                    id = ""
                    this.noItemsFound = true
                }
            }
        },
        validateQty(index)
        {
            if (!this.lockEntry)
            {
                var item = this.gri.gri_items[index];
                if(!isNaN(item.qty))
                {
                    if(item.qty < 0 )
                    {
                       item.qty =0
                    }
                    else if((item.qty * 1) > (item.qty_soh *1))
                    {
                        item.qty = 0
                    }
                }
                else
                {
                    item.qty = 0
                }
            }
        },
        setProduct(obj, index)
        {
            console.log(obj.id)
            if (!this.lockEntry)
            {
                this.prevWhId = this.gri.location_id

                if (obj != [])
                {
                    var name, id, qty_soh, unit_gmp

                    var isDuplicatedEntry = false
                    var items = this.gri.gri_items
                    
                    for(let n = 0; n < items.length; n++)
                    {
                        if (n != index)
                        {
                            if (items[n].product_id == items[index].product_id && items[index].product_id != "")
                            {
                                isDuplicatedEntry = true
                            }

                            if (isDuplicatedEntry)
                                break;
                        }
                    }
                    if (!isDuplicatedEntry)
                    {
                        if(obj !== null)
                        {
                            if (obj.id == "")
                            {
                                qty_soh = ""
                                unit_gmp = ""
                            }
                            else
                            {
                                name = obj.name
                                id = obj.id
                                qty_soh = obj.qty_soh
                                unit_gmp = obj.unit_gmp
                            }
                        }
                        else
                        {
                            name = ""
                            id = ""
                            qty_soh = ""
                            unit_gmp=""

                        }

                        if (isNaN(qty_soh))
                        qty_soh = ""
                    }
                    else
                    {
                        name = ""
                        id = ""
                        qty_soh = ""
                        unit_gmp=""
                    }

                    this.gri.gri_items[index].product_id = id
                    this.gri.gri_items[index].product_name = name
                    this.gri.gri_items[index].qty_soh = qty_soh
                    
                    this.gri.gri_items[index].unit_gmp = unit_gmp   
                    this.gri.gri_items[index].qty = 0   
                }
            }
        },
        hideModal () 
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Goods Return Inwards (GRIS)'})
        },
        closeGri()
        {
            this.modalCancelShow = true
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        
        fetch(griNum)
        {
            axios.post(apiGriGet, {gri_num:griNum},authHeader())
            .then (res => 
            { 
              var data
              data = res.data.data
              this.gri = data
              if(this.gri.country_id != null)
                {
                    if(this.gri.country_id == 'TH')
                    {
                        this.font = 'Garuda'
                    }
                    else if(this.gri.country_id == 'KH')
                    {
                        this.font = 'Hanumanb'
                    }
                    axios.get(apiCountryLookup, {params: {q: this.gri.country_id}})
                        .then(response => 
                        {

                            if (response.data != null)
                            {
                                this.list = response.data.data.list
                                this.item = this.list[0]
                                this.country_name = this.item.country_name
                                this.country_name = this.country_name.toUpperCase()
                            }
                        })
                }
              this.title = "Goods Return Inwards " + griNum
            })
            .catch(error => console.log(error)
          )
        },
        save()
        {
            this.modalShow = true
        },
        back()
        {
            this.$router.push({ name: 'Goods Return Inwards (GRIS)'})
        },
        handleOk()
        {
            axios.post(apiGriSave, this.gri, authHeader()).then (res => { 
                        var r = res.data
                        
                        if (r.code == 1)
                        {
                            this.griDocNo = r.data.gri_num
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.msg
                            this.$refs.myErrorModalRef.show()
                        }
                        })
            .catch(error => console.log(error))
        },
        handleCancelOk()
        {
            this.$router.push({ name: 'Goods Return Inwards (GRIS)'})
        }
    }
}
</script>
<style>
    .main {overflow-x: overlay;overflow-y: overlay;}
</style>




// WEBPACK FOOTER //
// src/views/gri/gri.vue